import * as types from './constants';

export default {

    // Set ebooks
    [types.GET_EBOOKS](state, data) {
        state.ebooks = data;
    },
    // Set ebooks filter
    [types.GET_EBOOKS_FILTER](state, data) {
        state.ebooksFilter = data;
    },
    // Set ebooks detail
    [types.GET_EBOOKS_DETAIL](state, data) {
        state.ebooksDetail = data;
    },
    // Set ebooks type
    [types.GET_EBOOKS_TYPE](state, data) {
        state.ebooksType = data;
    },
    //    // Set ebooks group
    //  	[types.GET_EBOOKS_GROUP](state, data) {
    // 	state.ebooksGroup = data;
    // },
    // Set ebooks type
    [types.GET_EBOOKS_CLASS](state, data) {
        state.ebooksClass = data;
    },
    // Get All Classes
    [types.GET_ALL_CLASSES](state, data) {
        state.allClasses = data;
    },
    // Get Book relation
    [types.GET_BOOK_RELATION](state, data) {
        state.bookRelation = data;
    },
    // Get Page search result
    [types.GET_PAGE_SEARCH](state, data) {
        state.searchResult = data;
    },
    // Get Book Filtes
    [types.GET_FILTERS](state, data) {
        state.filters = data;
    },

    [types.GET_TYPE_FILTERS](state, data) {
        state.typeFilters = data;
    },

    [types.GET_BOOK_FAQ](state, data) {
        state.ebookFAQ = data;
    },
    // Set exercise detail
    [types.GET_EXERCISE_DETAIL](state, data) {
        state.exerciseDetail = data;
    },

    [types.GET_QUESTION_EXERCISE](state, data) {
        state.question_exercise = data;
    },

    [types.GET_QUESTION_EXERCISE_INFO](state, data) {
        state.question_exercise_info = data;
    },

    [types.SET_QUESTION_ACTIVITY](state, data) {
        state.question_activity = data;
    },

    [types.OPEN_MATH_FORM](state, data) {
        state.open_math = data;
    },

    [types.SEND_MATH_VAL](state, data) {
        state.math_value = data;
    },

    [types.VALIDATE_QUESTION](state, value) {
        state.validate_question = value;
    },

    [types.CHECK_CORRECT_QUESTION](state, value) {
        state.check_answer = value;
    },

    [types.SET_QUESTION_VALID_DATA](state, value) {
        state.question_valid_data = value;
    },

    [types.SET_PARAM_SEARCH_RELATE_MEDIA](state, value) {
        state.paramSearchRelateMedia = value;
    },
    
    [types.GET_TRAINING_ID](state, value) {
        state.getTraningId = value
    },
    [types.EBOOK_SET_QUESTION_WORKING](state, value) {
        state.questionBookWorking = value
    },
    [types.EBOOK_SET_MEDIA_VIEWING](state, value) {
        state.mediaBookViewing = value
    },
    [types.EBOOK_SET_LESSON_VIEWING](state, value) {
        state.lessonBookViewing = value
    },
    [types.SET_DATA_DEACTIVE_BOOK](state, value) {
        state.dataBookDeactive = value
    },
    [types.SET_ID_BOOK_DEACTIVE_DONE](state, value) {
        state.idBookDeactiveDone = value
    }
};